import React from "react";
import {Asset, Link} from "../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";

const ProductCard = (props) => {
  if (props.displayAllSizesInArchive) {
    return (
      <div className='card card--product'>
        <Link to={props.permalink} className='card__product-image'>
          {props.gallery?.length > 0 && <Asset asset={props.gallery[0]}/>}
          {props.gallery?.length > 1 && 
            <div className='card__product-rollover'>
              <Asset asset={props.gallery[1]}/>
            </div>
          }
        </Link>
        {props.title && <h4><Link to={props.permalink}>{parse(props.title.replace(props.size, '', props.title))}</Link></h4>}
        <ul className='product-card__sizes'>
          {props.availableIn?.map((size, i) => (
            <li key={i}>
              <Link to={size.url?.permalink}>{size.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    )
  } else {
    return (
      <div className='card card--product'>
        <div className='card__product-image'>
          {props.gallery?.length > 0 && <Asset asset={props.gallery[0]}/>}
          {props.gallery?.length > 1 && 
            <div className='card__product-rollover'>
              <Asset asset={props.gallery[1]}/>
            </div>
          }
        </div>
        {props.title && <h4>{parse(props.title)}</h4>}
        {props.size && props.theme !== 'sunnyside' && <span>{props.size}</span>}
        {props.theme === 'sunnyside' && props.size && (
          <ul className='product-card__sizes'>
            <li>
              <span>{props.size}</span>
            </li>
          </ul>
        )}
      </div>
    )
  }
}

export default ProductCard